import {useState} from 'react';
import css from './tab.module.scss';
import {TabProps} from './tab.types';

const setClassNames = (selected: TabProps['selected'], tab: string) => {
	return `${css.tabItem} ${selected === tab ? css.active : null}`;
};

export const Tab = (props: TabProps): JSX.Element => {
	const [selected, setSelected] = useState(props.selected);

	const onTabClick = (tab: string) => {
		if (selected === tab) {
			return;
		}

		setSelected(tab);
		props.onChange(tab);
	};

	const tabs = props.tabNames.map((tab) => (
		<div onClick={() => onTabClick(tab)} className={setClassNames(selected, tab)} key={tab}>
			{tab}
		</div>
	));

	return <div className={css.container}>{tabs}</div>;
};
